export default "__VITE_ASSET__DubAr0rC__"